import { lazy, Suspense } from "react";

import { HeroV2 } from "@/components/sections/HeroV2";
import { PillarsBanner } from "@/components/sections/PillarsBanner";
import { CredibilityBar } from "@/components/sections/CredibilityBar";
import { DeferBlock } from "@/components/sections/DeferBlock";

// Calculadora: fica logo abaixo do hero, mas carrega react-hook-form + zod.
// Sai do caminho crítico do LCP e entra por chunk próprio.
const WhatsAppCostCalculator = lazy(() =>
  import("@/components/sections/WhatsAppCostCalculator").then((m) => ({
    default: m.WhatsAppCostCalculator,
  })),
);

// Seções abaixo da dobra: carregadas sob demanda para reduzir o JS no caminho crítico.
// O Vite gera chunks separados automaticamente para cada import() dinâmico.
const ProblemSection = lazy(() =>
  import("@/components/sections/ProblemSection").then((m) => ({ default: m.ProblemSection })),
);
const ProductEcosystem = lazy(() =>
  import("@/components/sections/ProductEcosystem").then((m) => ({ default: m.ProductEcosystem })),
);
const WhatsAppOfficial = lazy(() =>
  import("@/components/sections/WhatsAppOfficial").then((m) => ({ default: m.WhatsAppOfficial })),
);
const SolutionsBySegment = lazy(() =>
  import("@/components/sections/SolutionsBySegment").then((m) => ({
    default: m.SolutionsBySegment,
  })),
);
const RealResults = lazy(() =>
  import("@/components/sections/RealResults").then((m) => ({ default: m.RealResults })),
);
const LossCalculator = lazy(() =>
  import("@/components/sections/LossCalculator").then((m) => ({ default: m.LossCalculator })),
);
const CasesPlaceholder = lazy(() =>
  import("@/components/sections/CasesPlaceholder").then((m) => ({ default: m.CasesPlaceholder })),
);
const FAQAccordion = lazy(() =>
  import("@/components/sections/FAQAccordion").then((m) => ({ default: m.FAQAccordion })),
);
const FinalCtaForm = lazy(() =>
  import("@/components/sections/FinalCtaForm").then((m) => ({ default: m.FinalCtaForm })),
);

export function HomePage() {
  return (
    <>
      {/* Acima da dobra: sem lazy, vai no bundle principal */}
      <HeroV2 />
      {/* Mantém a posição original (logo após o hero), mas em chunk próprio */}
      <Suspense fallback={<div aria-hidden="true" className="min-h-[320px]" />}>
        <WhatsAppCostCalculator />
      </Suspense>
      <PillarsBanner />
      <CredibilityBar />

      {/* Abaixo da dobra: um chunk + um boundary de Suspense por seção */}
      <DeferBlock estimate={700}>
        <ProblemSection />
      </DeferBlock>
      <DeferBlock estimate={900}>
        <ProductEcosystem />
      </DeferBlock>
      <DeferBlock estimate={800}>
        <WhatsAppOfficial />
      </DeferBlock>
      <DeferBlock estimate={900}>
        <SolutionsBySegment />
      </DeferBlock>
      <DeferBlock estimate={700}>
        <RealResults />
      </DeferBlock>
      <DeferBlock estimate={800}>
        <LossCalculator />
      </DeferBlock>
      <DeferBlock estimate={600}>
        <CasesPlaceholder />
      </DeferBlock>
      <DeferBlock estimate={800}>
        <FAQAccordion />
      </DeferBlock>
      <DeferBlock estimate={700}>
        <FinalCtaForm />
      </DeferBlock>
    </>
  );
}
